import React from 'react';
import { UserCheck, Building, Globe, Phone } from 'lucide-react';

/**
 * Секция с настройками подписи письма
 */
const SignatureSection = ({ formData, handleInputChange, errors }) => {
  if (!formData.addSignature) {
    return (
      <div className="mb-6">
        <label className="flex items-center">
          <input
            type="checkbox"
            name="addSignature"
            checked={formData.addSignature}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <span className="ml-2 text-sm font-medium text-gray-700 dark:text-gray-300">
            Добавить подпись к письму
          </span>
        </label>
      </div>
    );
  }

  return (
    <div className="mb-6 bg-indigo-50 dark:bg-indigo-900/20 p-4 rounded-lg border border-indigo-100 dark:border-indigo-800">
      <h3 className="text-lg font-semibold text-indigo-800 dark:text-indigo-300 mb-4 flex items-center">
        <UserCheck className="w-5 h-5 mr-2 text-indigo-500" />
        Подпись письма
      </h3>
      
      <div className="flex items-center mb-4">
        <input
          type="checkbox"
          name="addSignature"
          checked={formData.addSignature}
          onChange={handleInputChange}
          className="form-checkbox"
          id="addSignature"
        />
        <label htmlFor="addSignature" className="ml-2 text-sm font-medium text-indigo-700 dark:text-indigo-300">
          Добавить подпись к письму
        </label>
      </div>

      <div className="grid grid-cols-1 gap-4">
        {/* Текст подписи */}
        <div>
          <label htmlFor="signature" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Текст подписи
          </label>
          <textarea
            id="signature"
            name="signature"
            value={formData.signature}
            onChange={handleInputChange}
            rows={3}
            placeholder="Ваше имя\nДолжность"
            className={`form-textarea w-full ${errors.signature ? 'input-error' : ''}`}
          />
          {errors.signature && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.signature}
            </p>
          )}
        </div>

        {/* Данные компании */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label htmlFor="companyName" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
              <Building className="w-4 h-4 mr-2 text-indigo-500" />
              Название компании
            </label>
            <input
              type="text"
              id="companyName"
              name="companyName"
              value={formData.companyName}
              onChange={handleInputChange}
              placeholder="ООО 'Компания'"
              className="form-input"
            />
          </div>

          <div>
            <label htmlFor="companyPhone" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
              <Phone className="w-4 h-4 mr-2 text-indigo-500" />
              Телефон
            </label>
            <input
              type="text"
              id="companyPhone"
              name="companyPhone"
              value={formData.companyPhone}
              onChange={handleInputChange}
              placeholder="+7 (999) 123-45-67"
              className={`form-input ${errors.companyPhone ? 'input-error' : ''}`}
            />
            {errors.companyPhone && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.companyPhone}
              </p>
            )}
          </div>
        </div>

        <div>
          <label htmlFor="companyWebsite" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Globe className="w-4 h-4 mr-2 text-indigo-500" />
            Веб-сайт
          </label>
          <input
            type="text"
            id="companyWebsite"
            name="companyWebsite"
            value={formData.companyWebsite}
            onChange={handleInputChange}
            placeholder="https://example.ru"
            className={`form-input ${errors.companyWebsite ? 'input-error' : ''}`}
          />
          {errors.companyWebsite && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.companyWebsite}
            </p>
          )}
        </div>
      </div>

      {/* Предпросмотр подписи */}
      <div className="mt-4 p-3 bg-white dark:bg-gray-800 border border-indigo-100 dark:border-indigo-800 rounded">
        <h4 className="text-xs font-medium text-indigo-700 dark:text-indigo-300 mb-2">Предпросмотр подписи:</h4>
        <div className="text-sm text-gray-700 dark:text-gray-300 whitespace-pre-line">
          -- <br />
          {formData.signature}<br />
          {formData.companyName && <>{formData.companyName}<br /></>}
          {formData.companyPhone && <>{formData.companyPhone}<br /></>}
          {formData.companyWebsite && <>{formData.companyWebsite}</>}
        </div>
      </div>
    </div>
  );
};

export default SignatureSection;